/*** IMPORTS FROM imports-loader ***/
(function() {

define([], function(){

  var eventManifest =
    {
      // TODO: Goal should be to make this upper block into userEvents, userDrivenEvents, or something similar.
      events: [
        {
          media: [
            'expandMediaView',
            'closeMediaView',
            'mediaLoaded'
          ]
        },
        {
          breadcrumbs: ['breadcrumbsLoaded']
        },
        {
          trackif: ['trackifSubmitted']
        },
        {
          ssku: [
            'sskuInteraction',
            'sskuChange',
            'modalOpen',
            'calculateEstimate',
            'sskuRendered',
            'sskuMetaDataLoaded',
            'sdskuChange'
          ]
        },
        {
          shippingOptions: [
            'shippingOptionsLinkClicked',
            'shippingOptionsZipCodeWasChecked',
            'shippingOptionsZipCodeWasChanged',
            'shippingOptionsZipCodeCheckError'
          ]
        },
        {
          aisleAndBay: [
            'aisleAndBayTooltipOpened',
            'aisleAndBayTextMeClicked',
            'aisleAndBayTextMeClickedWithCoupon',
            'aisleAndBayTextMeErrorHappened'
          ]
        },
        {
          bazaarVoice: ['bazaarVoiceRatingsReviewLoaded']
        },
        {
          aisleBay: ['aisleBayDisplayed']
        },
        {
          cart: [
            'addToCart',
            'addToCartAnalytics',
            'addToCartAnalyticsBackorder',
            'multiItemAddToCart',
            'paypalAddToCart',
            'addtoCartOverlay',
            'subscribe'
          ]
        },
        {
          bundle: [
            'bundleDDOAnalytics',
            'bundlingQuickViewModalStatusUpdate'
          ]
        },
        {
          instantRebates: ['instantRebatesLinkClicked']
        },
        {
          fbr: ['fbrLinkClicked']
        },
        {
          fbt: [
            'fbtLinkClicked',
            'fbtInitComplete'
          ]
        },
        {
          irg: [
            'irgComplete',
            'irgLinkClicked',
            'singleItemAddToCart'
          ]
        },
        {
          expressDelivery: [
            'expressDeliveryError',
            'expressDeliveryOverlayLinkClicked',
            'expressDeliveryOverlayDisplayed'
          ]
        },
        {
          appliance: [
            'applianceError',
            'applianceZipCodeEntered',
            'applianceAvailabilityChecked',
            'applianceAvailabilityCheckedV3',
            'bundleAvailabilityChecked',
            'bundleAvailabilityCheckedV3',
            'bundleRequestResolved'
          ]
        },
        {
          threeSixty: [
            'threeSixtyLoadingStart',
            'threeSixtyAutoSpinComplete',
            'threeSixtyJSONRequestError',
            'threeSixtyTimeoutThresholdReached',
            'threeSixtyThumbnailFailedToLoad',
            'threeSixtyImageFailedToLoad',
          ]
        },
        {
          ecoRebates: ['ecoRebatesLinkClicked']
        },
        {
          priceDetails: ['priceDetailsLinkClicked']
        },
        {
          promotions: ['promotionLinkClicked']
        },
        {
          resize: [
            'resizeToExtraSmall',
            'resizeToSmall',
            'resizeToMedium',
            'resizeToLarge',
            'resizeToExtraLarge'
          ]
        },
        {
          pipModel: ['pipModelQuantityUpdated']
        },
        {
          quantity: [
            'minimumQuantityWarning',
            'clearMinimumQuantityWarning',
            'quantityErrorAnalytics'
          ]
        },
        {
          b2bOnly: [
            'loginButtonClicked',
          ]
        },
        {
          customer: [
            'customerQuantityErrorStateChanged',
            'customerSubscriptionStateChanged',
            'customerOnlineQuantityErrorStateChanged'
          ]
        },
        {
          badging: ['badgingInitialized']
        },
        {
          requestQuote: [
            'requestQuoteButtonClicked',
            'dualPathRequestQuoteButtonClicked'
          ]
        },
        {
          scroll: ['scrollAnimationComplete']
        },
        {
          calculator: [
            'quantityCalculatorStateChanged',
            'measureCalculatorStateChanged'
          ]
        },
        {
          consumerCreditMessage: [
            'applyNowClicked',
            'messageDisplayed'
          ]
        },
        {
          augmentedReality: [
            'augmentedRealityDrawerActivated'
          ]
        },
        {
          attachLabor: [
            'installationOptionsAtcClicked',
            'attachLaborOptInStateChanged',
            'zipCodeChanged',
            'newZipCodeProcessed'
          ]
        },
        {
          dualPath: [
            'dualPathOptInStateChanged',
            'dualPathBuyBeltLinkClicked'
          ]
        },
        {
          tabs: [
            'specsTabSelected'
          ]
        },
        {
          cards: [
            'cardOverlayDisplayed',
            'cardOverlayHidden',
            'cardClicked'
          ]
        },
        {
          automotive: [
            'vehicleChanged',
            'fitmentBadgeUpdated'
          ]
        },
        {
          packages: [
            'addToCartAnalytics',
          ]
        },
        {
          disclaimerMessage: [
            'legalDisclaimerClicked',
            'messageDisplayed'
          ]
        },
        {
          instantCheckout: [
            'instantCheckoutAnalytics'
          ]
        },
        {
          customProductOffering: [
            'cpoInfoReceived',
            'irgItemsReceived'
          ]
        },
        {
          multiSkuBulk: [
            'multiSkuBulkAnalytics',
            'multiSkuBulkCartAdd',
            'multiSkuBulkCartStash'
          ]
        },
        {
          buyOneGetOne: [
            'buyOneGetOneAnalytics',
          ]
        }
      ],


      pipLifecycleEvents: [
        {
          attachLabor: [
            'attachLaborProcessed'
          ]
        }
      ]
    };

  return eventManifest;
});

}.call(window));